// importing other Bootstrap Javascript Modules
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';

import { gsap } from "gsap";
// importing GSAP plugins
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);

// keep gsap running on browser tab change
function tickGSAPWhileHidden(value) {
    if (value === false) {
        document.removeEventListener("visibilitychange", tickGSAPWhileHidden.fn);
        return clearInterval(tickGSAPWhileHidden.id);
    }
    const onChange = () => {
        clearInterval(tickGSAPWhileHidden.id);
        if (document.hidden) {
            gsap.ticker.lagSmoothing(0); // keep the time moving forward (don't adjust for lag)
            tickGSAPWhileHidden.id = setInterval(gsap.ticker.tick, 500);
        } else {
            gsap.ticker.lagSmoothing(500, 33); // restore lag smoothing
        }
    };
    document.addEventListener("visibilitychange", onChange);
    tickGSAPWhileHidden.fn = onChange;
    onChange(); // in case the document is currently hidden.
}
tickGSAPWhileHidden(true);

let smoother;
function smoothScroll() {
    if(window.innerWidth >= 992) {
        smoother = ScrollSmoother.create({
            smooth: 0.8,
            effects: true,
        });
    }
}

// fade up animation on scroll
function fadeUpOnScroll() {
    const fadeUpEl = document.querySelectorAll('.fade-up');
    fadeUpEl.forEach((item) => {
        gsap.to(item, {
            y: 0,
            autoAlpha: 1,
            duration: 0.8,
            ease: "ease",
            scrollTrigger: {
                trigger: item,
                start: "top-=100 bottom-=15%",
                // markers: true,
            },
        })
    })
}
function fadeOutOnScroll() {
    const fadeUpEl = document.querySelectorAll('.fade-out');
    fadeUpEl.forEach((item) => {
        gsap.fromTo(item, {
            autoAlpha: 0,
        }, {
            autoAlpha: 1,
            duration: 0.8,
            ease: "ease",
            scrollTrigger: {
                trigger: item,
                start: "top-=100 bottom-=20%",
                // markers: true,
            },
        })
    })
}

function preloader() {
    const petraText = document.querySelector('.preloader__petra-text');
    const petraTextDescription = document.querySelector('.preloader__description-text');
    const progressBar = document.querySelector('.preloader__progress-bar');
    const progressBarLoader = document.querySelector('.preloader__progress');

    // animate navbar & banner section
    let navbar = document.querySelector('.navbar');
    let banner = document.querySelector('.banner__wrapper');
    let bannerTl = gsap.timeline();
    bannerTl.fromTo(banner, {
        y: "20%",
        scale: 1.1
    }, {
        y: "0%",
        scale: 1,
        duration: 1.1,
        ease: "power3.inOut",
    })
    bannerTl.pause();

    // hide loader after window loaded
    const preloader = document.querySelector('.preloader');
    const preloaderWrapper = document.querySelector('.preloader__wrapper');
    let hidePreloaderTl = gsap.timeline();
    hidePreloaderTl.to(preloader, {
        y: "-100%",
        duration: 1,
        ease: "power3.inOut",
    })
    .to(preloaderWrapper, {
        opacity: 0,
        duration: 0.3,
    }, "-=1")
    hidePreloaderTl.pause();

    // showing petra text & description on preloader section
    let preloaderTl = gsap.timeline();
    preloaderTl.to(progressBar, {
        width: "100%",
        opacity: 1,
        duration: 0.8,
        ease: "back.out(1)",
    })
    .to(petraTextDescription, {
        x: "0%",
        opacity: 1,
        duration: 0.8,
        ease: "back.out(1)",
    })
    .to(petraText, {
        opacity: 1,
        duration: 0.8,
        onComplete: () => {
            let progressTl = gsap.timeline();
            progressTl.to(progressBarLoader, {
                width: "70%",
                duration: 1.1,
                ease: "back.out(1)",
            })
            .to(progressBarLoader, {
                width: "100%",
                duration: 0.8,
                ease: "back.out(0.4)",
                onComplete: () => {
                    hidePreloaderTl.play();
                    bannerTl.play();
                }
            })
        }
    }, "-=0.4")
}

function floatingButton() {
    const scrollTop = document.querySelector('.floating-button__link--scroll-top');
    // const floatingTrigger = document.querySelector('.floating-trigger');

    // if (window.innerWidth >= 992) {
    //     gsap.fromTo(scrollTop, {
    //         autoAlpha: 0,
    //     }, {
    //         autoAlpha: 0.5,
    //         duration: 0.4,
    //         ease: "ease",
    //         scrollTrigger: {
    //             trigger: floatingTrigger,
    //             start: "bottom center",
    //             scrub: true,
    //             // markers: true
    //         },
    //     })
    // }

    scrollTop.addEventListener("click", () => {
        gsap.to(window, { duration: 0.4, scrollTo: `.banner` });
    })
}
function floatingButtonOnScroll() {
    const scrollTop = document.querySelector('.floating-button__link--scroll-top');

    // get window top
    const doc = document.documentElement;
    let top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

    if (top == 0) {
        scrollTop.classList.remove('show');
    } else {
        scrollTop.classList.add('show');
    }
}

function navbarProductList() {
    const productListLink = document.querySelectorAll('.navbar__megamenu-list-link[data-image]');
    productListLink.forEach((e) => {        
        // each megamenu has its own image, so swap only the one inside the same megamenu
        const megamenuImage = e.closest('.navbar__megamenu').querySelector('.navbar__megamenu-image');

        e.addEventListener('mouseenter', (el) => {
            megamenuImage.src = el.target.getAttribute('data-image');
        })
    })
}

function navbarOnScroll() {
    const navbar = document.querySelector('.navbar');

    // get window top
    const doc = document.documentElement;
    let top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    
    if (top == 0) {
        navbar.classList.remove('navbar-scroll');
        navbar.addEventListener('mouseleave', (e) => {
            navbar.classList.remove('navbar-scroll');
        })
    } else {
        if(!navbar.classList.contains('navbar-scroll')) {
            navbar.classList.add('navbar-scroll');
        } else {
            navbar.addEventListener('mouseenter', (e) => {
                navbar.classList.remove('navbar-scroll');
            })
            navbar.addEventListener('mouseleave', (e) => {
                navbar.classList.add('navbar-scroll');
            })
        }
    }
}

function showNavbarDropdown() {
    const navbarDropdownLinks = document.querySelectorAll('.navbar__dropdown-link')
    const navbarOverlay = document.querySelector('.navbar__overlay')
    const offcanvasNavbar = document.querySelector('#offcanvasNavbar')
    const navbar = document.querySelector('.navbar')
    const isDesktop = () => window.innerWidth >= 992
    let wasDesktop = isDesktop()

    const closeAllDropdown = () => {
        navbarDropdownLinks.forEach((link) => {
            link.classList.remove('active')
            link.setAttribute('aria-expanded', 'false')
        })
        navbarOverlay.classList.remove('show')
        navbar.classList.remove('navbar--megamenu-open')
    }

    const openDropdown = (navbarDropdownLink) => {
        closeAllDropdown()
        // keeps the header solid while a megamenu is open, even when scrolled (see .navbar--megamenu-open)
        navbar.classList.add('navbar--megamenu-open')
        navbarDropdownLink.classList.add('active')
        navbarDropdownLink.setAttribute('aria-expanded', 'true')
    }

    // listeners are bound once and check the breakpoint when they fire,
    // so resizing (e.g. the mobile address bar showing/hiding) never stacks duplicate listeners
    navbarDropdownLinks.forEach((navbarDropdownLink) => {
        navbarDropdownLink.setAttribute('aria-expanded', 'false')

        navbarDropdownLink.addEventListener('mouseenter', () => {
            if (!isDesktop()) return

            openDropdown(navbarDropdownLink)
            navbarOverlay.classList.add('show')
        })

        navbarDropdownLink.addEventListener('click', (e) => {
            if (isDesktop()) {
                // dropdown without its own page (e.g. Referensi) only opens the megamenu
                if (navbarDropdownLink.getAttribute('href') === '#') {
                    e.preventDefault()
                }
                return
            }

            // mobile: tap toggles this dropdown and closes the other one
            e.preventDefault()

            if (navbarDropdownLink.classList.contains('active')) {
                closeAllDropdown()
            } else {
                openDropdown(navbarDropdownLink)
            }
        })
    })

    navbarOverlay.addEventListener('mouseenter', () => {
        if (isDesktop()) closeAllDropdown()
    })

    // start collapsed every time the mobile menu is opened again
    if (offcanvasNavbar) {
        offcanvasNavbar.addEventListener('hidden.bs.offcanvas', closeAllDropdown)
    }

    window.addEventListener('resize', () => {
        if (isDesktop() !== wasDesktop) {
            wasDesktop = isDesktop()
            closeAllDropdown()
        }
    })
}

function footerResponsive() {
    const footerSocialMediaWrapper = document.querySelector('.footer__social-media-wrapper');
    const footerCta = document.querySelector('.footer__cta');
    const footerContact = document.querySelector('.footer__contact');
    const footerIntro = document.querySelector('.footer__intro');
    const footerNewsletterSection = document.querySelector('.footer__section-newsletter');
    const footerSocialMedia = document.querySelector('.footer__social-media');
    const footerCopyright = document.querySelector('.footer__copyright');

    // copyright section

    if (window.innerWidth < 992) {
        footerNewsletterSection.append(footerSocialMedia);
        footerNewsletterSection.append(footerCopyright);
        footerContact.append(footerNewsletterSection);
    } else {
        footerSocialMediaWrapper.append(footerSocialMedia);
        footerCta.append(footerNewsletterSection);
        footerIntro.append(footerCopyright)
    }    
}

// Bootstrap modals have to be direct children of <body>: inside #smooth-content the ScrollSmoother transform
// makes their position: fixed relative to the content instead of the screen, so they open off-screen
function moveModalsToBody() {
    document.querySelectorAll('.modal').forEach((modal) => document.body.appendChild(modal));
}

// pause (not kill) the smoother while a modal is open: killing every ScrollTrigger also removed the pin
// spacers, so the page behind the modal jumped up, and pins without their own re-init were lost for good
function stopSmoothScrollOnModal() {
    const scrollbarWidth = (window.innerWidth - document.body.clientWidth) + 'px';
    const customNavbar = document.querySelector('.navbar');
    const smoothWrapper = document.querySelector('#smooth-wrapper');

    document.addEventListener('show.bs.modal', () => {
        // ScrollSmoother only exists at >= 992px (see smoothScroll)
        if (smoother) {
            smoother.paused(true)
            // Bootstrap pads the body for the hidden scrollbar, the fixed wrapper needs the same
            if (smoothWrapper) smoothWrapper.style.paddingRight = scrollbarWidth
        }
        if (customNavbar) {
            customNavbar.style.paddingRight = scrollbarWidth
        }
    })

    document.addEventListener('hidden.bs.modal', () => {
        if (smoother) {
            smoother.paused(false)
            if (smoothWrapper) smoothWrapper.style.paddingRight = null
        }
        if (customNavbar) {
            customNavbar.style.paddingRight = null
        }
    })
}

function mailchimpForm() {
    if(mc4wp) {
        mc4wp.forms.on('success', () => {
            const mailchimpModal = document.querySelector('#mailchimpModal');
            const mailchimpModalBs = new Modal(mailchimpModal, { keyboard: false });
    
            // const preloader = document.querySelector(".preloader");
            // preloader.remove();
    
            gsap.to(window, { 
                duration: 0.4,
                scrollTo: `.footer`,
                // onComplete: () => {
                //     mailchimpModalBs.show();
                // }
            });
    
        })
        
        mc4wp.forms.on('error', () => {
            const mailchimpModal = document.querySelector('#mailchimpModal');
            const mailchimpModalBs = new Modal(mailchimpModal, { keyboard: false });
    
            // const preloader = document.querySelector(".preloader");
            // preloader.remove();
    
            gsap.to(window, { 
                duration: 0.4,
                scrollTo: `.footer`,
                // onComplete: () => {
                //     mailchimpModalBs.show();
                // }
            });
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    moveModalsToBody();
    smoothScroll();
    fadeUpOnScroll();
    fadeOutOnScroll();
    floatingButton();
    floatingButtonOnScroll();
    navbarProductList();
    navbarOnScroll();
    showNavbarDropdown();
    footerResponsive();
    stopSmoothScrollOnModal();
    mailchimpForm();
    
    // const preloaderSection = document.querySelector('.preloader');
    // if(preloaderSection) {
    //     preloader();
    // }
    
})

document.addEventListener('scroll', () => {
    navbarOnScroll();
    floatingButtonOnScroll();
});

window.addEventListener('resize', () => {
    // footerResponsive();
})

export { gsap, ScrollTrigger, ScrollSmoother, smoother, Modal }